import { ParamMap, Params } from '@angular/router';

import { ROUTES } from '../constants/routes.constant';

const AUTH_REDIRECT_QUERY_KEYS = Object.freeze({
  from: 'from',
  redirectRoute: 'redirectRoute',
});

const WORDPRESS_REDIRECT_SOURCE = 'wp';
const GOLF_CLUB_MANAGER_ROLE = 'GOLF_CLUB_MANAGER';
const INVALID_REDIRECT_TARGETS = new Set<string>([ROUTES.LOGIN, ROUTES.ACCEPT_TC]);

export function buildWpAuthRedirectQueryParams(redirectRoute: string): Params | undefined {
  const safeRedirectRoute = sanitizeAuthRedirectRoute(redirectRoute);

  if (!safeRedirectRoute) {
    return undefined;
  }

  return {
    [AUTH_REDIRECT_QUERY_KEYS.from]: WORDPRESS_REDIRECT_SOURCE,
    [AUTH_REDIRECT_QUERY_KEYS.redirectRoute]: safeRedirectRoute,
  };
}

export function getForwardedAuthRedirectQueryParams(queryParamMap: ParamMap): Params | undefined {
  if (isWpAuthRedirect(queryParamMap)) {
    const redirectRoute = sanitizeAuthRedirectRoute(queryParamMap.get(AUTH_REDIRECT_QUERY_KEYS.redirectRoute));

    if (!redirectRoute) {
      return undefined;
    }

    return {
      [AUTH_REDIRECT_QUERY_KEYS.from]: WORDPRESS_REDIRECT_SOURCE,
      [AUTH_REDIRECT_QUERY_KEYS.redirectRoute]: redirectRoute,
    };
  }

  return undefined;
}

export function getPostLoginRedirectRoute(queryParamMap: ParamMap): string | null {
  if (isWpAuthRedirect(queryParamMap)) {
    return sanitizeAuthRedirectRoute(queryParamMap.get(AUTH_REDIRECT_QUERY_KEYS.redirectRoute));
  }
  return null;
}

export function getDefaultPostLoginRoute(userRole?: string | null): string {
  return userRole === GOLF_CLUB_MANAGER_ROLE ? ROUTES.BOOKING_LOG : ROUTES.DASHBOARD;
}

function isWpAuthRedirect(queryParamMap: ParamMap): boolean {
  return queryParamMap.get(AUTH_REDIRECT_QUERY_KEYS.from) === WORDPRESS_REDIRECT_SOURCE;
}

function sanitizeAuthRedirectRoute(redirectRoute: string | null): string | null {
  if (!redirectRoute || !redirectRoute.startsWith('/') || redirectRoute.startsWith('//')) {
    return null;
  }

  const normalizedRedirectRoute = removeWpSourceQueryParam(redirectRoute);
  const normalizedPath = normalizedRedirectRoute.replace(/^\/+/, '').split(/[?#]/)[0];

  if (!normalizedPath || INVALID_REDIRECT_TARGETS.has(normalizedPath)) {
    return null;
  }

  return normalizedRedirectRoute;
}

function removeWpSourceQueryParam(redirectRoute: string): string {
  const url = new URL(redirectRoute, window.location.origin);

  if (url.searchParams.getAll(AUTH_REDIRECT_QUERY_KEYS.from).includes(WORDPRESS_REDIRECT_SOURCE)) {
    url.searchParams.delete(AUTH_REDIRECT_QUERY_KEYS.from);
  }

  const search = url.searchParams.toString();

  return `${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
}
